<template>
    <div class="backdrop" style="z-index:100" @click.self="onNo">
        <div class="message-box">
            <div style="display:flex;justify-content:center">
                <span>{{ title }}</span>
            </div>
            <div style="margin-bottom:10px"><hr /></div>
            <div style="display:flex;justify-content:center;font-size: 14px;margin-bottom: 10px;">
                <span>{{ message }}</span>
            </div>
            <div style="display:flex;justify-content:space-between; flex-direction: column;height:100%">
                <div style="height: 150px;">
                    <select v-model="selectedOption" size="9" style="width:100%">
                        <option v-for="option in options" :key="option.globalId" :value="option" @dblclick="onYes">{{ option.optionName }}</option>
                    </select>
                </div>
                <div class="message-box-button-bar" v-if="!processing">
                    <button class="message-box-button" @click="onYes" ref="btnYes" v-if="yesText!='' && selectedOption != null ">
                        {{ yesText }}
                    </button>
                    <button class="message-box-button" @click="onNo" ref="btnNo" v-if="noText!=''">
                        {{ noText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from "vue";

export default {    
    setup() {        
        

        const processing = ref(false)
        const btnNo = ref(null);
        const btnYes = ref(null);
        const options = ref([]);
        const selectedOption = ref(null);
        const title = ref("")
        const yesText = ref("")        
        const noText = ref("")
        var yesAction = null;
        var noAction = null;
        const message = ref("")

        const showDialog = async (pOptions, pTitle, pMessage    , pYesAction, pNoAction, pYesText = "Select", pNoText = "Cancel", defaultYes = false ) => {            
            title.value = pTitle
            yesText.value = pYesText
            noText.value = pNoText
            yesAction = pYesAction
            noAction = pNoAction
            options.value = pOptions;
            message.value = pMessage

            setTimeout(function() {
                if (defaultYes) {
                    btnYes.value.focus();
                } else {
                    btnNo.value.focus();
                }
            }, 50);
        }

        const onNo = async () => {                        
            if (yesAction != null) {
                await noAction()
            }
        };

        const onYes = async () => {
            if (yesAction != null) {
                await yesAction(selectedOption.value)
            }
        };        

        return { 
            showDialog,
            btnNo, 
            btnYes, 
            onNo, 
            onYes,
            
            processing,            
            title,
            yesText,
            noText,
            options,
            selectedOption,
            message

        };
    }
};
</script>

<style scoped>
.message-box {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -105px;
    margin-left: -255px;
    width: 500px;
    height: 300px;
    background: var(--main-background);
    border-radius: 10px;
    padding: 10px;
    border: 1px solid var(--card-body-border);
}

.message-box-button-bar {
    display: flex;
    justify-content: flex-end;    
    padding: 5px;
    margin: 0px;
}

.message-box-button {
    /* background-color: cornflowerblue; */
    color: var(--button-color);
    padding: 10px;
    margin-right: 10px;
    width: 75px;
    cursor: pointer;
}
</style>
